module.exports = __webpack_public_path__ + "static/img/appdow_bk4_dt.1ab7da6.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/appdow_bk4_dt.gif
// module id = v+5R
// module chunks = 4